<template>
  <div id="admin_businesses_daily_reg_rpt">
    <CardedTable :items="items" :headers="headers" :show_search="false" :show_description="true" :show_header_bar="false">
      <template v-slot:controls>
            <v-row class="bb-1-dotted pl-5 pr-5 pt-4 mb-1" no-gutters>
            <v-col no-gutters class="ma-0">
                <DateField
                label="Start Date"
                v-model="start_date_display"
                :disabled="is_loading"
                cmp_class="mt-0 mb-0 pb-0 pt-0"
                :min="'2018-01-01'"
                :max="date_today"
                :error_messages="errors"
                ></DateField>
            </v-col>
            <v-col no-gutters class="ma-0">
                <DateField
                label="End Date"
                v-model="end_date_display"
                :disabled="is_loading"
                :min="start_date_display"
                :max="date_today"
                cmp_class="mt-0 mb-0 pb-0 pt-0"
                ></DateField>
            </v-col>
            <v-col cols="2" no-gutters class="ma-0 text-right">
                <v-btn
                class="hgt-40 round-4 white--text"
                tile
                filled
                ripple
                color="primary"
                :disabled="is_loading"
                @click="refresh_table"
                >
                Refresh
                </v-btn>
            </v-col>
            </v-row>
      </template>

      <template v-slot:description>
          <h4>{{report_message}}</h4>
      </template>

      <template v-slot:[`item.owners_name`]="{ item }">
        {{ item.user.first_name }} {{ item.user.last_name }}
      </template>

      <template v-slot:[`item.is_verified`]="{ item }">
        <span class="red--text" v-if="parseInt(item.is_verified) == 0"
          ><b>Pending</b></span
        >
        <span class="blue--text" v-if="parseInt(item.is_verified) == 1"
          ><b>Processing</b></span
        >
        <span class="green--text" v-if="parseInt(item.is_verified) == 2"
          ><b>Verified</b></span
        >
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <v-btn @click="on_view_item(item)" x-small rounded text color="success">
          <v-icon>mdi-eye</v-icon>
        </v-btn>
      </template>
    </CardedTable>
  </div>
</template>

<script>
import CardedTable from "../../../components/CardedTable";
import RedText from "../../../components/RedText";
import DateField from "../../../components/DateField";
import ServerClient from "../../../lib/ServerClient";
import Utils from '../../../lib/Utils';
export default {
  name: "AdminBusinessesDailyRegistrations",
  components: {
    CardedTable,
    DateField,
    RedText
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      default: () => {
        return ServerClient.Login.get_logged_in_user();
      },
    },
  },
  data: () => {
    return {
      _user: null,
      items: [],
      headers: [
        {
          text: "Name",
          align: "start",
          sortable: true,
          value: "name",
          filterable: true,
        },
        {
          text: "Owner",
          align: "start",
          sortable: true,
          value: "owners_name",
          filterable: true,
        },
        {
          text: "User Name",
          align: "start",
          sortable: true,
          value: "user.email",
          filterable: true,
        },
        {
          text: "Join Date",
          align: "start",
          sortable: true,
          value: "joined_on",
          filterable: true,
        },
        {
          text: "Verification",
          align: "start",
          sortable: true,
          value: "is_verified",
          filterable: true,
        },
        { text: "", value: "actions", sortable: false, align: "end" },
      ],
      start_date_display: Utils.get_today_date_str(),
      end_date_display: Utils.get_today_date_str(),
      date_today: Utils.get_today_date_str(),
      report_message: "",
      errors: [],
    };
  },
  methods: {
    load_items(start_time,end_time){
      this.$emit("on-show-loader");
      ServerClient.Businesses.get_daily_registration_report(
        {
            start_time: start_time,
            end_time: end_time
        },
        (res) => {
          this.items = res;
          this.process_report_message();
          this.$emit("on-hide-loader");
        },
        (errors) => {
          this.$emit("on-hide-loader");
          console.log(
            "Errors while loading busineeses on admin no verification docs businesses list",
            errors
          );
        }
      );
    },
    on_view_item(item) {
      this.$router.push("/admin/businesses/list/view/" + item.id);
    },
    refresh_table(){
        this.errors = [];
        var start_time_str = this.start_date_display + " 00:30:00 AM ";
        var start_time = Utils.date_str_to_php_time(start_time_str);
        var end_time_str = this.end_date_display + " 11:30:00 PM ";
        var end_time = Utils.date_str_to_php_time(end_time_str);
        if(start_time == end_time){
            this.errors.push("Start time cannot be equal to end time");
            return false;
        }
        if(start_time > end_time){
            this.errors.push("Start time cannot be greater than end time");
            return false;
        }

        this.load_items(start_time,end_time);
    },
    process_report_message(){
        var num_str = "";
        if(this.items.length == 0){
            num_str = " were no  businesses ";
        }else if(this.items.length == 1){
            num_str = " was only (1) one business ";
        }else if(this.items.length > 1){
            num_str = " were "+ this.items.length +" businesses ";
        }

        var start_word = Utils.date_str_to_words(this.start_date_display,true,"of");
        var end_word = Utils.date_str_to_words(this.end_date_display,true,"of");
        var msg = "";
        if(this.start_date_display == this.end_date_display){
            msg = "There " + num_str + " registered on the " + start_word;
        }else{
            msg = "There " + num_str + " registered between the " + start_word + " and the " + end_word;
        }
        this.report_message = msg;
    }
  },
  mounted() {
    this._user = ServerClient.Login.get_logged_in_user();
    //nyd
    //if is not admin please redirect this user to the login screen

    this.$emit("set-page-attributes", {
      title: "Daily registrations Report",
      crumps: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin",
        },
        {
          text: "Buinesses",
          disabled: false,
          href: "/admin/businesses",
        },
        {
          text: "Daily Regs Rpt",
          disabled: true,
          href: "/admin/businesses/reports/registrations/daily",
        },
      ],
    });

    this.refresh_table();
    

    var options = {
      offset: 50,
      duration: 1000,
      easing: "easeInOutCubic",
    };
    this.$vuetify.goTo("#admin_businesses_daily_reg_rpt", options);
  },
};
</script>